export class AudioContextFactory {
  public static create(): AudioContext {
    let Class = AudioContext || window['webkitAudioContext'];
    let audioContext = new Class();
    return audioContext;
  }
}
